import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DetalhesProcesso} from "../../../models/detalhes-processo";
import {ProcessoService} from "../../../services/processo-service";
import Swal from "sweetalert2";
import {ToastrService} from "ngx-toastr";
import {TipoAcao} from "../../../../cadastro/gerais/models/tipo-acao";
import {CadastrosGeraisService} from "../../../../cadastro/services/cadastros-gerais.service";
import {DocumentoProcessoService} from "../../../services/documento-processo.service";
import {HttpResponse} from "@angular/common/http";
import {DetalhesComponent as DetalheTarefa} from "../../../tarefa/pages/detalhes/detalhes.component";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import { NovaComponent as NovaTarefaComponent } from "../../../tarefa/pages/nova/nova.component";
import { NovoComponent as AtendimentoNovoComponent } from "../../../../cadastro/atendimento/novo/novo.component";
import { NovoComponent as DocumentoNovoComponent } from "../../../documento-processo/pages/novo/novo.component";
import { AudienciaService } from "../../../services/audiencia-service";
import { NovoComponent as AudienciaNovoComponent } from "../../../audiencia/novo/novo.component";
import { DetalhesComponent as AudienciaDetalhesComponent } from "../../../audiencia/detalhes/detalhes.component";

@Component({
    selector: 'app-detalhes-processo',
    templateUrl: './detalhes.component.html',
    styleUrl: './detalhes.component.css',
    standalone: false
})
export class DetalhesComponent {
  @ViewChild(DetalheTarefa) detalhesComponent: DetalheTarefa;
  @ViewChild(NovaTarefaComponent) novaTarefaComponent: NovaTarefaComponent;
  @ViewChild(AtendimentoNovoComponent) novoAtendimentoComponent: AtendimentoNovoComponent;
  @ViewChild(DocumentoNovoComponent) novoDocumentoComponent: DocumentoNovoComponent;
  @ViewChild(AudienciaNovoComponent) novoAudienciaComponent: AudienciaNovoComponent;
  @ViewChild(AudienciaDetalhesComponent) detalhesAudienciaComponent: AudienciaDetalhesComponent;
  loading = false;
  menu = false;
  processo = new DetalhesProcesso();
  listaTipoAcao: TipoAcao[] = [];
  id = 0;
  modalNovoDocumento = false;
  listaAudiencias: any[] = [];
  totalAudiencias = 0;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '250px',
    minHeight: '200px',
    placeholder: 'Digite a descrição aqui...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  constructor(private route: ActivatedRoute,
              private processoServico: ProcessoService,
              private documentoServico: DocumentoProcessoService,
              private audienciaService: AudienciaService,
              private toastr: ToastrService,
              private geraisService: CadastrosGeraisService,
              private router: Router) {
    this.id = this.route.snapshot.params['id'];
    this.buscarProcessoPorId(this.id);
    this.listarTipoAcao();
    this.buscarAudienciasPorProcesso(this.id);
  }

  buscarProcessoPorId(id: number){
    this.processoServico.buscarPorId(id).subscribe(response => {
      this.loading = false;
      if(response.sucesso)
      {
        this.processo = response.dados;
      }
    });

  }

  buscarAudienciasPorProcesso(id: number) {
    this.audienciaService.buscarPorProcesso(id).subscribe((response: any) => {
      if (response.sucesso) {
        this.listaAudiencias = response.dados.itens;
        this.totalAudiencias = response.dados.itens.length;
      }
    });
  }

  abrirModalNovaTarefa(){
    if (this.novaTarefaComponent){
      this.novaTarefaComponent.telaProcesso = true;
      this.novaTarefaComponent.processoId = this.id;
      this.novaTarefaComponent.showModalNova();
    }
  }

  abrirModalNovoAtendimento(){
    if (this.novoAtendimentoComponent){
      this.novoAtendimentoComponent.isModal = true;
      this.novoAtendimentoComponent.showModalNovoAtendimento();
    }
  }

  abrirModalNovoDocumento(){
    if (this.novoDocumentoComponent) {
      this.novoDocumentoComponent.isModal = true;
      this.novoDocumentoComponent.showModalNovoDocumento();
    }
  }

  fecharModalNovoDocumento(){
    if (this.novoDocumentoComponent) {
      this.novoDocumentoComponent.fecharModal();
    }
  }

  abrirModalNovaAudiencia() {
    if (this.novoAudienciaComponent) {
      this.novoAudienciaComponent.isModal = true;
      if (this.novoAudienciaComponent.formCadastrar) {
        this.novoAudienciaComponent.formCadastrar.get('processoId')?.setValue(this.id);
      }
      this.novoAudienciaComponent.showModal();
    }
  }

  abrirDetalhesAudiencia(id: number) {
    if (this.detalhesAudienciaComponent) {
      this.detalhesAudienciaComponent.abrirModal(id);
    }
  }

  public buscarDetalheTarefa(id: number){
    this.detalhesComponent.showModalDetalhes();
    this.detalhesComponent.buscarDetalhesTarefa(id);
  }

  download(id: number, nome: string, extensao: string){
    this.documentoServico.downloadDocumento(id).subscribe((res: any) => {
      if (res.sucesso && res.dados) {
        const link = document.createElement('a');
        link.href = res.dados;
        link.target = '_blank';
        link.download = nome + extensao;
        link.click();
      } else {
        this.toastr.error(res.mensagem || "Erro ao obter o link de download");
      }
    })
  }

  voltar(){
    this.router.navigate(['/juridico/processo']);
  }

  salvarAlteracoes(){
    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed){
        this.loading = true;
        this.processoServico.alterar(this.processo).subscribe(result => {
          if(result.sucesso){
            this.buscarProcessoPorId(this.processo.id);
            this.toastr.success("Processo alterado com sucesso.");
          }
          else {
            this.toastr.error(result.errors[0].mensagem);
          }
          this.loading = false;
        }, error =>{
          if(error.status === 404){
            this.toastr.error(error.errors[0].mensagem);
          }
          else
            this.toastr.error(error.error);

          this.loading = false;
        });
      }
    });
  }

  private listarTipoAcao(){
    this.geraisService.selecionarListaTipoAcoes().subscribe( response =>{
      if(response.sucesso){
        this.listaTipoAcao = response.dados;
      }
    })
  }
}
